var service = 'estado';

angular.module('eficienciaFiscalModule')
    .service(service + 'Service', ['$timeout', 'httpService', 'pathService',
        function ($timeout, httpService, pathService) {

            var route = pathService.getApiUrl() + '/estados/',
                screenId = "#base";

            this.getList = function (callback, event, loadText) {
                return httpService.request({
                    url: route,
                    method: "GET",
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            }
        }
    ]);
